import { render, staticRenderFns } from "./tabbar-health.vue?vue&type=template&id=5a75fa8c&scoped=true"
import script from "./tabbar-health.vue?vue&type=script&lang=js"
export * from "./tabbar-health.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a75fa8c",
  null
  
)

export default component.exports